import { defineMessages, type MessageDescriptor } from 'react-intl';

export const slackEnterpriseGridAuthUpgradeMessages: Record<
	'title' | 'description' | 'connectText',
	MessageDescriptor
> = defineMessages({
	title: {
		id: 'oauth-banner.slack-enterprise-grid-auth-upgrade-title',
		defaultMessage: 'Reconnect Slack to see messages from multiple workspaces',
		description: 'Title for the Enterprise Grid Slack authorization-upgrade banner.',
	},
	description: {
		id: 'oauth-banner.slack-enterprise-grid-auth-upgrade-description',
		defaultMessage:
			"Your organization's Slack connection was upgraded. Reconnect Slack to see more in Rovo Search and Chat.",
		description: 'Body for the Enterprise Grid Slack authorization-upgrade banner.',
	},
	connectText: {
		id: 'oauth-banner.reconnect-slack',
		defaultMessage: 'Reconnect',
		description: 'CTA for the Enterprise Grid Slack authorization-upgrade banner.',
	},
});
